import { defineComponent as _defineComponent } from 'vue'

const __default__ = defineComponent({ name: 'AnimatedCheckmark' });

import { computed, defineComponent } from 'vue';

/**
 * A checkmark animation wrapped in a Vue component based on a codepen by Simon Wuyts.
 */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  /**
   * The color of the checkmark.
   *
   * Defaults to white.
   */
  color: { type: String, default: 'white' },
},
  setup(__props) {

const props = __props;



const style = computed(() => {
  return `stroke: rgb(var(--v-theme-${props.color}));
            fill: rgb(var(--v-theme-${props.color}));
            stroke: ${props.color}; fill: ${props.color};`;
});

return { __sfc: true,props, style }
}

})